import { CreateProjectRequest, Project, ProjectCloneRequest, ProjectCloneResponse } from 'api/model.ts';
import instance from '../axios_instance';

export const getProjects = async ({
  pageParam,
  pageSize = 100,
}: {
  pageParam?: number;
  pageSize?: number;
}): Promise<Project[]> => {
  const response = await instance.get<Project[]>(`/projects?page=${pageParam}&page_size=${pageSize}`);
  return response.data;
};

export const getProject = async (id: string): Promise<Project> => {
  const response = await instance.get<Project>(`/projects/${id}`);
  return response.data;
};

export const createProject = async (project: CreateProjectRequest): Promise<Project> => {
  const response = await instance.post<Project>(`/projects`, project);
  return response.data;
};

export const removeProject = async (id: string) => {
  return await instance.delete(`/projects/${id}`);
};

export const updateProject = async (id: string, project: CreateProjectRequest): Promise<Project> => {
  const response = await instance.put<Project>(`/projects/${id}`, project);
  return response.data;
};

export const cloneProject = async (projectId: string, request: ProjectCloneRequest): Promise<ProjectCloneResponse> => {
  const response = await instance.post<ProjectCloneResponse>(`/projects/${projectId}/clone`, request);
  return response.data;
};
